import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-th-megaphonesimple",
  "use": "icon-th-megaphonesimple-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-th-megaphonesimple\">\n<path d=\"M27.5675 10.8325L5.56 4.0825C5.26213 3.99562 4.94814 3.97924 4.64284 4.03465C4.33755 4.09006 4.04934 4.21574 3.801 4.40175C3.55266 4.58776 3.351 4.82901 3.21198 5.1064C3.07296 5.38379 3.00039 5.68972 3 6V24C3 24.5304 3.21071 25.0391 3.58579 25.4142C3.96086 25.7893 4.46957 26 5 26C5.19125 26.0001 5.38152 25.9727 5.565 25.9188L16 22.7163V24C16 24.5304 16.2107 25.0391 16.5858 25.4142C16.9609 25.7893 17.4696 26 18 26H22C22.5304 26 23.0391 25.7893 23.4142 25.4142C23.7893 25.0391 24 24.5304 24 24V20.2625L27.5675 19.1688C27.9804 19.0447 28.3425 18.7913 28.6004 18.4458C28.8583 18.1003 28.9984 17.6811 29 17.25V12.75C28.9981 12.3191 28.8579 11.9002 28.6 11.555C28.3421 11.2098 27.9802 10.9565 27.5675 10.8325ZM16 20.625L5 24V6L16 9.375V20.625ZM22 24H18V22.1025L22 20.875V24ZM27 17.25H26.9862L18 20.01V9.99L26.9862 12.74H27V17.24V17.25Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/th-megaphonesimple.svg
// module id = dWNZ
// module chunks = 83